<script setup lang="ts">
import { usePWAUpdate } from '../composables/usePWAUpdate'

const { needRefresh, applyUpdate, dismiss } = usePWAUpdate()
</script>

<template>
  <Transition name="slide-up">
    <div
      v-if="needRefresh"
      class="fixed bottom-md left-md right-md z-50 max-w-md mx-auto bg-background-secondary border border-border-subtle rounded-md shadow-lg p-md"
      role="alert"
    >
      <p class="text-text-primary text-sm mb-sm">新版本可用，刷新应用？</p>
      <div class="flex gap-sm justify-end">
        <button
          class="px-sm py-xs text-sm text-text-secondary border border-border-subtle rounded-md hover:bg-background-primary"
          @click="dismiss"
        >
          稍后
        </button>
        <button
          class="px-sm py-xs text-sm text-white bg-brand-primary rounded-md hover:opacity-90"
          @click="applyUpdate"
        >
          刷新
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.2s ease-out;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}
</style>
